import { configureStore } from '@reduxjs/toolkit';
import userManagementReducer from './userManagementSlice';
import notificationReducer from './notificationSlice';

export const store = configureStore({
  reducer: {
    userManagement: userManagementReducer,
    notifications: notificationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
